<template>
  <div>
    <client-settings
      :header="header"
      :header-description="headerDescription"
      :display-settings="settings"/>
  </div>
</template>

<script>
import ClientSettings from './ClientSettings'

export default {
  components: { ClientSettings },
  data () {
    return {
      header: 'Armoire Announcements',
      headerDescription: 'Updates on new features, special offers, and Armoire news',
      settings: [
        {
          name: 'Push',
          settingKey: 'notifyAnnouncementsPush'
        }
      ]
    }
  }
}
</script>
